var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerGap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3346_16551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2181 128.847C31.3689 120.517 21.3961 107.026 17.4937 91.3425C13.5913 75.6591 16.079 59.0678 24.4094 45.2185C32.7399 31.3693 46.2307 21.3965 61.9141 17.4941C77.5976 13.5917 94.1888 16.0794 108.038 24.4098C128.624 36.7926 140.192 60.0311 137.553 83.6407C137.485 84.2526 137.297 84.845 137 85.3842C136.703 85.9234 136.302 86.3988 135.822 86.7833C135.341 87.1677 134.789 87.4537 134.198 87.6249C133.606 87.7961 132.987 87.8492 132.375 87.7811C131.763 87.713 131.171 87.525 130.632 87.228C130.093 86.9309 129.617 86.5306 129.233 86.0498C128.848 85.569 128.562 85.0172 128.391 84.4258C128.22 83.8345 128.167 83.2152 128.235 82.6034C130.465 62.6179 120.644 42.9326 103.206 32.4435C91.4872 25.3946 77.4484 23.2897 64.1778 26.5917C50.9072 29.8937 39.4919 38.3322 32.4431 50.0508C25.3942 61.7694 23.2893 75.8082 26.5913 89.0788C29.8933 102.349 38.3318 113.765 50.0504 120.814C67.4885 131.303 89.4808 130.753 106.091 119.418C107.118 118.717 108.381 118.453 109.603 118.684C110.825 118.915 111.905 119.622 112.605 120.649C113.306 121.676 113.57 122.939 113.339 124.161C113.108 125.383 112.401 126.462 111.374 127.163C91.754 140.558 65.8043 141.23 45.2181 128.847Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3346_16551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerGap);
export default __webpack_public_path__ + "static/media/SpinnerGap.728d1a8e9ffd3363609b01f40ad32684.svg";
export { ForwardRef as ReactComponent };